import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wall-image-item"
}
const _hoisted_2 = {
  key: 0,
  class: "ml-[-6px] mt-[-6px] tag z-[1] items-center h-[36px] leading-[36px] rounded-full"
}
const _hoisted_3 = { class: "relative g-image-component" }
const _hoisted_4 = { class: "absolute top-2 right-2" }
const _hoisted_5 = { class: "flex flex-col mt-[20px] gap-[5px] min-h-10" }
const _hoisted_6 = { class: "item__name" }
const _hoisted_7 = { class: "item__price" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "NT.", -1)
const _hoisted_9 = { class: "orange-price ml-2 line-through text-light-gary-text-color" }
const _hoisted_10 = {
  key: 0,
  class: "mr-1"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("NT. ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_ctx.productRef)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (
        _ctx.moment
          .utc(_ctx.moment.utc(_ctx.productRef.OnShelfDate, 'YYYYMMDDHHmmss').local())
          .diff(Date.now(), 'days') > -30
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " NEW "))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.productRef.Checked || false)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  iconName: "selected",
                  width: '20px'
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_FavoriteButton, {
              class: "favButton",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('addToCollect', _ctx.productRef)), ["stop"])),
              isLike: true,
              width: '20px'
            })
          ])
        ])), [
          [_directive_lazy, _ctx.productRef.Image.PcWeb, "background-image"]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.unescapeHTML(_ctx.productRef.Name)), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["font-normal text-xs sm:text-[0.8125rem] tracking-[.1em]", {
          'text-light-gary-text-color': _ctx.productRef.IsEndProduct === 1,
          'text-primary-color': _ctx.productRef.IsEndProduct === 0,
        }])
          }, _toDisplayString(_ctx.productRef.SubName), 3),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.productRef.UnitFeeReal), 1),
            _createElementVNode("span", _hoisted_9, [
              (_ctx.productRef.UnitFeeReal !== _ctx.productRef.UnitFeeOri)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", null, _toDisplayString(_ctx.productRef.UnitFeeOri), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_12
      ]))
    : _createCommentVNode("", true)
}